"use client";

import Chart from "@/components/ui/Chart";
import { buildSemanticChartData } from "@/lib/charts/buildChartData";
import type { SemanticChartData } from "@/lib/charts/types";

interface SemanticChartProps {
  chartData: SemanticChartData;
}

export default function SemanticChart({ chartData }: SemanticChartProps) {
  return (
    <figure className="semantic-chart card">
      <Chart
        type={chartData.type}
        data={buildSemanticChartData(chartData)}
        title={chartData.title}
        height={300}
      />
      {chartData.caption && (
        <figcaption className="semantic-chart-caption">{chartData.caption}</figcaption>
      )}
      <style jsx>{`
        .semantic-chart {
          padding: var(--space-4);
          margin: var(--space-4) 0;
        }
        .semantic-chart-caption {
          margin-top: var(--space-3);
          font-size: var(--text-sm);
          color: var(--text-muted);
          text-align: center;
          line-height: var(--lh-normal);
          font-style: italic;
        }
      `}</style>
    </figure>
  );
}
